import CloseButton from "src/components/button/close-button";
import Text from "src/components/text/text";
import { useNavigationStore } from "src/store/navigationStore";
import { useNavigate } from "react-router-dom";
import { useAppStore } from "@/store/appStore";
import { ShareButton } from "@/components/button/share-button";
import ImageButton from "@/components/button/image-button";
import Image from "@/components/image";
import { useEffect, useState, useRef } from "react";
import ItemSelector from "@/components/selector/item-selector";
// import { getVenueModelConfig } from "@/const/venue_model/venue_model_config";
import {
  MapInformation,
  getVenueIdByVenueCode,
  getVenueModelConfigByVenueId,
  getVenueModelConfigByVenueCode,
  getMapSettingByVenueCode,
} from "src/utils/map-util";
import { useExplorationStore } from "@/store/explorationStore";

export default function ExplorationHeader({
  venueCode,
}: {
  venueCode: string;
}) {
  // const setConversationId = useNavigationStore(
  //   (state) => state.setConversationId,
  // );
  const setChatType = useAppStore((state) => state.setChatType);
  const prevChatType = useExplorationStore((state) => state.prevChatType);

  let navigate = useNavigate();
  const [showFloorSelectorState, setShowFloorSelectorState] = useState(false);
  const [currentLcMapIdState, setCurrentLcMapIdState] = useState("");
  const [currentFloorNameState, setCurrentFloorNameState] = useState("");
  const [currentFloorShortNameState, setCurrentFloorShortNameState] =
    useState("");
  const [floorSelectionListState, setFloorSelectionListState] = useState<
    string[]
  >([]);

  const setExplorationCameraMode = useExplorationStore(
    (state) => state.setExplorationCameraMode,
  );
  const setCurrentLcMapId = useExplorationStore(
    (state) => state.setCurrentLcMapId,
  );
  const clearData = useExplorationStore((state) => state.clearData);

  const triggerResetPositionRotationEvent = useExplorationStore(
    (state) => state.triggerResetPositionRotationEvent,
  );

  const triggerLeaveVenue = useExplorationStore(
    (state) => state.triggerLeaveVenue,
  );

  const mapSettingRef = useRef<MapInformation>(null);

  useEffect(() => {
    const mapSetting = getMapSettingByVenueCode(venueCode);
    mapSettingRef.current = mapSetting;
    if (mapSetting?.modelConfig?.floor) {
      const floorlist = mapSetting.modelConfig.floor.filter((f) => f.isNotReady == null).sort((a, b) => a.name.localeCompare(b.name)).map((f) => f.name);
      if (floorlist) {
        setFloorSelectionListState(floorlist);
        if (floorlist.length > 0) {
          const defaultFloor = mapSetting.modelConfig.floor.find(
            (f) => f.lcMapId === mapSetting.modelConfig?.defaultLcMapId,
          );
          setCurrentLcMapIdState(defaultFloor?.lcMapId ?? "");
          setCurrentFloorNameState(defaultFloor?.name ?? "");
          setCurrentFloorShortNameState(defaultFloor?.shortName ?? "");
        }
      }
    }
  }, [venueCode]);

  const resetChat = () => {
    // setConversationId("");
    // reset previous chat type so that home chat will not highlight "exploration" tab
    setChatType(prevChatType);
    clearData();
    leaveVenue();
  };

  const leaveVenue = () => {
    triggerLeaveVenue();
    setTimeout(() => {
      navigate(`/explore/${venueCode}`);
    }, 2000);
  };

  const onResetCamera = () => {
    triggerResetPositionRotationEvent();
  };

  const onChangeFloor = (value: string) => {
    setShowFloorSelectorState(false);
    console.log("floor level changed", value);

    if (mapSettingRef.current) {
      const newFloor = mapSettingRef.current.modelConfig?.floor?.find(
        (f) => f.name === value,
      );
      if (newFloor) {
        setCurrentLcMapId(newFloor.lcMapId ?? "");
        setCurrentFloorNameState(newFloor?.name ?? "");
        setCurrentFloorShortNameState(newFloor.shortName ?? "");
      }
    }
  };

  const FloorSelector = () => {
    return (
      <ItemSelector
        isOpen={showFloorSelectorState}
        onSelect={(value) => {
          onChangeFloor(value);
        }}
        selectionList={floorSelectionListState}
        currentValue={currentFloorNameState}
      />
    );
  };

  return (
    <>
      <div className="flex w-full justify-end items-center px-[20px] pt-[20px]">
        <button
          className="flex bg-glass floor-indicator items-center justify-between"
          onClick={() => setShowFloorSelectorState(true)}
        >
          <Text text={currentFloorShortNameState} className=" text-500" />
          <Image
            src="/assets/icon_joystick_down.png"
            alt="Clock icon"
            width={24}
            height={24}
          />
        </button>
        <div className="flex w-full justify-end z-50 gap-4">
          <ImageButton
            className="button-glass"
            src="/assets/icon_reset_camera.png"
            onClick={() => onResetCamera()}
            alt="rotate icon"
            size={24}
          />
          <div>
            <ShareButton />
          </div>
          <CloseButton
            goBack={false}
            onClick={() => resetChat()}
            withGlassBg={true}
          />
        </div>
        {<FloorSelector />}
      </div>
    </>
  );
}
